<template>
    <div class="loader-request">
        <div class="loader-container">
            <img class="loader" src="../../assets/loader-turquesa.gif" alt="">
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
    .loader-request{
        background-color: rgba(255, 255, 255, 0.6);
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        z-index: 1100;
        .loader-container{
            .loader{

            }
        }
    }
</style>
